import { object } from 'yup'
import { FormSchema } from '../Wizard/Form/Types'
import { topic } from './shared/topic'
import { brandVoiceId, tone } from './shared/voiceTones'
import { count } from './shared/count'
import { links } from './shared/links'
import { avoid } from './shared/avoid'
import { Twitter } from 'blaze-ui/icons'
import { sourceMaterialIds } from './shared/sourceMaterials'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { includeImages } from './shared/includeImages'
import { MultiStepSchema, StepSchema } from 'components/Wizards/schemas/Types'
import { SelectImages } from 'components/Wizards/schemas/shared/selectImages'
import { crossPostAccounts } from './shared/crossPostAccounts'
import { brandKitId } from './shared/brandKitId'
import { language } from './shared/language'
import { TextChannels } from '../../../constants'
import { includeEmojis } from './shared/includeEmojis'

const meta = {
  type: ChannelType.Tweets,
  icon: Twitter,
  steps: ['Context', 'Generate Ideas'],
  title: TextChannels[ChannelType.Tweets].name,
  submitLabel: 'Generate Post Ideas',
  previewUrl:
    'https://res.cloudinary.com/almanac/image/upload/v1710183792/Home%20Card%20Previews/guxh6oo1ezhztatbgnik.png',
}

const fields = {
  topic: topic.meta({ label: 'What is the topic for your post?', generationType: meta.type }),
  include_emojis: includeEmojis,
  count: count.default(3).min(1).max(20).meta({ label: 'How many post ideas do you want? (Max 20)' }),
  brand_voice_id: brandVoiceId,
  brand_kit_id: brandKitId,
  source_material_ids: sourceMaterialIds,
  tone,
  language,
  include_images: includeImages.meta({
    description: 'An image will make your post far more engaging and attention grabbing',
  }),
  links: links.meta({ collapsible: true }),
  avoid: avoid.meta({ collapsible: true }),
  cross_post_accounts: crossPostAccounts,
}

export const TweetsSchema = object(fields).meta(meta) as FormSchema<GenerationType | ChannelType>

export const TweetsMultiStepSchema: MultiStepSchema<ChannelType.Tweets> = {
  steps: [
    TweetsSchema.omit(['include_images']).meta({
      title: 'Purpose & Goals',
      submitLabel: 'Select Images',
    }) as StepSchema,
    SelectImages.meta({ submitLabel: meta.submitLabel, type: meta.type }) as StepSchema,
  ],
  meta: {
    ...meta,
    type: ChannelType.Tweets,
    channel: ChannelType.Tweets,
  },
}
